(async()=>{
  const baseComponent=await import(window.theme.modules.baseComponent);
  customElements.define('cart-counter',class extends baseComponent.default{
    render(){this.on('updateCart',()=>this._fetchCart(),false);this.on('cartChange',()=>this._fetchCart(),false);}
    async _fetchCart(){
      const id=this.requestId=(this.requestId||0)+1;this.controller?.abort();this.controller=new AbortController();
      try{const response=await fetch(this.getAttribute('cart-url')+'.js',{signal:this.controller.signal,cache:'no-store'});if(!response.ok)return;const data=await response.json();if(id===this.requestId && this.isConnected)this._update(data);}catch{/* Preserve the last confirmed count. */}
    }
    _update(data){if(!Number.isInteger(data.item_count)||data.item_count<0)return;this.textContent=data.item_count;this.toggleAttribute('empty',data.item_count===0);}
    disconnectedCallback(){super.disconnectedCallback();this.controller?.abort();this.requestId=(this.requestId||0)+1;}
  });
})();
